import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import classnames from 'clsx';
import PropTypes from 'prop-types';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { ERR, WRN } from '../../../enums/address-verification-status';

import style from '../address-validation.module.less';

const issueSeverityMetadata = {
  warning: {
    icon: faExclamationTriangle,
    style: style.warning,
  },
  error: {
    icon: faExclamationCircle,
    style: style.error,
  },
};

const VALIDATION_ISSUE_STATES = {
  [ERR]: issueSeverityMetadata.error,
  [WRN]: issueSeverityMetadata.warning,
};

const ValidationIssue = ({
  className = '',
  validation = '',
  validationMessage = '',
  validationMessageClassName,
  shouldTruncateText = true,
}) => {
  const issueState = VALIDATION_ISSUE_STATES[validation];

  return (
    <div className={classnames(className, style['validation-issue'], issueState?.style)}>
      <FontAwesomeIcon icon={issueState?.icon} />
      {shouldTruncateText ? (
        <Tooltip>
          <div className={classnames(style.message, validationMessageClassName)}>{validationMessage}</div>
          <TooltipContent>{validationMessage}</TooltipContent>
        </Tooltip>
      ) : (
        <div className={classnames(style.message, validationMessageClassName)}>{validationMessage}</div>
      )}
    </div>
  );
};

ValidationIssue.propTypes = {
  className: PropTypes.string,
  validation: PropTypes.string,
  validationMessage: PropTypes.string,
  validationMessageClassName: PropTypes.string,
  shouldTruncateText: PropTypes.bool,
};

export default ValidationIssue;
